<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'资讯管理'},{name:'资讯列表',goback:true},{name:'资讯明细'}]" :title="'资讯明细'"/>
            <!-- 详情 -->
            <div class="box detailBas">
            <el-card class="basic box_card" header="基础信息" shadow="never">
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">资讯标题：</div>
                        <div class="content">{{dataInfo.title||'--'}}</div>
                    </div>
                    </el-col>
                    
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">资讯简介：</div>
                        <div class="content">{{dataInfo.summary||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">来源：</div>
						<div class="content">{{dataInfo.source||'--'}}</div>
                    </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="child">
					    <div class="name">封面：</div>
					    <div class="content" ><img class="logos" :src="dataInfo.frontPath+dataInfo.logo" /> </div>
					</div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="richText">
                        <div class="name">资讯详情：</div>
                        <div class="content" v-html="dataInfo.content">{{dataInfo.content||'--'}}</div>
                    </div>
                    </el-col>
                    </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="attachment">
                        <div class="name">附件：</div>
                        <ul class="content">
							<li v-for="(i,index) in dataInfo.fileList" :key="index">
								<span>{{i.fileName}}</span>
								<i class="el-icon-download" @click="downLoad(dataInfo.frontPath+i.filePath)"></i>
							</li>
                        </ul>
                    </div>
                    </el-col>
                  </el-row>
            </el-card>
            <el-card class="basic box_card mt16" header="其它信息" shadow="never">
                  <el-row>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">发布账号：</div>
                        <div class="content">{{dataInfo.createUserName||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">发布时间：</div>
                        <div class="content">{{dataInfo.createTime||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">更新账号：</div>
                        <div class="content">{{dataInfo.modifyUserName||'--'}}</div>
                    </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                        <div class="name">更新时间：</div>
                        <div class="content">{{dataInfo.updateTime||'--'}}</div>
                    </div>
                    </el-col>
                  </el-row>
            </el-card>
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            id:"",//详情
			dataInfo:'',
        }
    },
    methods:{
		getDetail(){
			this.$axiosc.get('backstage/news/details/'+this.id).then((r)=>{
			    if(r.code==200){
			        this.dataInfo=r.data;
			    }else{
			        this.$alert(r.msg)
			    }
			})
		},
        //下载附件
        downLoad:function({fileName,filePath}){
           const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
    },
    created(){
        if(this.$route.query.id){
            this.id=this.$route.query.id;
			this.getDetail();
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height:100%;
     overflow: hidden;
     padding:0;
     background: transparent !important;
    .box{
      overflow-x: hidden;
     overflow-y: auto;
     height: calc(100% - 40px);
		.content{
			/deep/ p{
				line-height: 20px;
			}
		}
    }
}
.box{
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
    .tableChild{
      margin-top:8px !important;
    }
    .child,.attachment{
      margin-top:8px;
    }
}
</style>